
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[venueSlug]",
      function () {
        return require("private-next-pages/[venueSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[venueSlug]"])
      });
    }
  